import { Select, Input, DatePicker, Button } from "antd"

const { RangePicker } = DatePicker;

export const ThirdPartyBillingDetailsColumns = (billingInvoiceNames, customerUidData, setSurchargeModalOpen, setSurchargeModalContent, setCurrentModalTarget) => [
    {
        title: '状态',
        dataIndex: 'status',
        key: 'status',
        search: true,
        renderFormItem: (item, { type, defaultRender, ...rest }) => {
            return (
                <Select
                    style={{
                        width: '100%',
                        textAlign: 'left'
                    }}
                    placeholder="请选择"
                    allowClear
                    options={[
                        { label: 'UID异常', key: '1', value: '1' },
                        { label: '重复子tracking', key: '2', value: '2' },
                        { label: 'surcharge异常', key: '3', value: '3' },
                        { label: '待计算', key: '4', value: '4' },
                        { label: '计费异常', key: '5', value: '5' },
                        { label: '待出账', key: '6', value: '6' },
                        { label: '已出账', key: '7', value: '7' },
                        { label: '未知', key: '8', value: '8' }
                    ]}
                    />
            )
        },
    },
    {
        title: 'Tracking Number',
        dataIndex: 'tracking_number',
        key: 'tracking_number',
        search: true,
        renderFOrmItem: (item, { type, defaultRender, ...rest }) => {
            return (
                <Input
                    style={{
                        width: '100%',
                        textAlign: 'left'
                    }}
                    placeholder="请输入（支持模糊查询）"
                />
            )
        },
    },
    {
        title: '费用',
        dataIndex: ['fee_json', 'total'],
        key: 'fee_json',
        search: false,
        render: (text, record) => {
            if (record.status === "待出账" || record.status === "已出账"){
                return <Button type="link" onClick={() => {
                    const newModalContent = Object.entries(record.fee_json).map(([key, value], index) => ({
                        key: index,
                        type: key,
                        amount: value
                    }));
                    setCurrentModalTarget('费用');
                    setSurchargeModalContent(newModalContent);
                    setSurchargeModalOpen(true);
                }}>
                    {text}
                </Button>
            } else {
                return text;
            }
        }
    },
    {
        title: 'Surcharge Details',
        dataIndex: 'surcharge_json',
        key: 'surcharge_json',
        search: false,
        render: (text, record) => {
            return <Button type="link" onClick={() => {
                const newModalContent = Object.entries(text).map(([key, value], index) => ({
                    key: index,
                    type: key,
                    amount: value
                }));
                setCurrentModalTarget('附加费');
                setSurchargeModalContent(newModalContent);
                setSurchargeModalOpen(true);
            }}>
                附加费详情
            </Button>
        }
    },
    {
        title: '导入批次编号',
        dataIndex: ['billing_invoice', 'name'],
        key: 'billing_invoice',
        search: true,
        renderFormItem: (item, { type, defaultRender, ...rest }) => {
            return (
                <Select
                    style={{
                        width: '100%',
                        textAlign: 'left'
                    }}
                    allowClear
                    showSearch
                    placeholder="请选择"
                    options={billingInvoiceNames?.map((item) => ({
                        label: item.name,
                        key: item.id,
                        value: item.id
                    }))}
                    filterOption={(input, option) =>
                        option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                    
                />
            )
        }
    },
    {
        title: 'UID',
        dataIndex: ['customer', 'uid'],
        key: 'uid',
        search: true,
        renderFormItem: (item, { type, defaultRender, ...rest }) => {
            return (
                <Select
                    style={{
                        width: '100%',
                        textAlign: 'left'
                    }}
                    placeholder="请选择"
                    options={customerUidData?.map((item) => ({
                        label: item.uid,
                        key: item.id,
                        value: item.id
                    }))}
                    allowClear
                    showSearch
                    filterOption={(input, option) =>
                        option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                />
            )
        }
    },
    {
        title: 'Master Tracking',
        dataIndex: 'master_tracking_number',
        key: 'master_tracking_number',
        search: true,
        renderFormItem: (item, { type, defaultRender, ...rest }) => {
            return (
                <Input
                    style={{
                        width: '100%',
                        textAlign: 'left'
                    }}
                    placeholder="请输入（支持模糊查询）"
                />
            )
        },
    },
    {
        title: 'Customer ID',
        dataIndex: ['rate_json', 'Customer ID'],
        key: 'customer_id',
        search: false,
    },
    {
        title: 'Invoice Date',
        dataIndex: ['rate_json', 'Invoice Date'],
        key: 'invoice_date',
        search: false,
    },
    {
        title: 'Service Code',
        dataIndex: 'service_code',
        key: 'service_code',
        search: false,
    },
    {
        title: 'Net Charge Amount',
        dataIndex: ['rate_json', 'Net Charge Amount'],
        key: 'net_charge_amount',
        search: false,
    },
    {
        title: 'Service Type',
        dataIndex: 'service_type',
        key: 'service_type',
        search: true,
        renderFormItem: (item, { type, defaultRender, ...rest }) => {
            return (
                <Input
                    style={{
                        width: '100%',
                        textAlign: 'left'
                    }}
                    placeholder="请输入（支持模糊查询）"
                />
            )
        },
    },
    {
        title: 'Shipment Date',
        dataIndex: 'shipment_date',
        key: 'shipment_date',
        search: true,
        renderFormItem: (item, { type, defaultRender, ...rest }) => {
            return <RangePicker />
        },
    },
    {
        title: '是否需要Dispute',
        dataIndex: 'requires_dispute',
        key: 'requires_dispute',
        search: true,
        hidden: true,
        hiddenInForm: true,
        renderFormItem: (item, { type, defaultRender, ...rest }) => {
            return (
                <Select
                    style={{
                        width: '100%',
                        textAlign: 'left'
                    }}
                    placeholder="请选择"
                    options={[
                        { label: '是', key: '1', value: 1 },
                        { label: '否', key: '0', value: 0 }
                    ]}
                    allowClear
                />
            )
        },
    },
    {
        title: 'Ref 1',
        dataIndex: ['rate_json', 'Ref 1'],
        key: 'ref_1',
        search: false,
    },
    {
        title: 'Ref 2',
        dataIndex: ['rate_json', 'Ref 2'],
        key: 'ref_2',
        search: false,
    },
    {
        title: 'Ref 3',
        dataIndex: ['rate_json', 'Ref 3'],
        key: 'ref_3',
        search: false,
    },
    {
        title: 'Curr',
        dataIndex: ['rate_json', 'Curr'],
        key: 'curr',
        search: false,
    },
    {
        title: 'Call Tag',
        dataIndex: ['rate_json', 'Call Tag'],
        key: 'call_tag',
        search: false,
    },
    {
        title: 'Dec Value',
        dataIndex: ['rate_json', 'Dec Value'],
        key: 'dec_value',
        search: false,
    },
    {
        title: 'Customs',
        dataIndex: ['rate_json', 'Customs'],
        key: 'customs',
        search: false,
    },
    {
        title: 'Cus Curr',
        dataIndex: ['rate_json', 'Cus Curr'],
        key: 'cus_curr',
        search: false,
    },
    {
        title: 'Pcs',
        dataIndex: ['rate_json', 'Pcs'],
        key: 'pcs',
        search: false,
    },
    {
        title: 'Bill Wt',
        dataIndex: ['rate_json', 'Bill Wt'],
        key: 'bill_wt',
        search: false,
    },
    {
        title: 'Orig Wt',
        dataIndex: ['rate_json', 'Orig Wt'],
        key: 'orig_wt',
        search: false,
    },
    {
        title: 'Wt Unit',
        dataIndex: ['rate_json', 'Wt Unit'],
        key: 'wt_unit',
        search: false,
    },
    {
        title: 'Length',
        dataIndex: ['rate_json', 'Length'],
        key: 'length',
        search: false,
    },
    {
        title: 'Width',
        dataIndex: ['rate_json', 'Width'],
        key: 'width',
        search: false,
    },
    {
        title: 'Height',
        dataIndex: ['rate_json', 'Height'],
        key: 'height',
        search: false,
    },
    {
        title: 'Dim Unit',
        dataIndex: ['rate_json', 'Dim Unit'],
        key: 'dim_unit',
        search: false,
    },
    {
        title: 'Divisor',
        dataIndex: ['rate_json', 'Divisor'],
        key: 'divisor',
        search: false,
    },
    {
        title: 'Shipper Name',
        dataIndex: ['rate_json', 'Shipper Name'],
        key: 'shipper_name',
        search: false,
    },
    {
        title: 'Shipper Company',
        dataIndex: ['rate_json', 'Shipper Company'],
        key: 'shipper_company',
        search: false,
    },
    {
        title: 'Shipper Dept',
        dataIndex: ['rate_json', 'Shipper Dept'],
        key: 'shipper_dept',
        search: false,
    },
    {
        title: 'Shipper Address 1',
        dataIndex: ['rate_json', 'Shipper Address 1'],
        key: 'shipper_address_1',
        search: false,
    },
    {
        title: 'Shipper Address 2',
        dataIndex: ['rate_json', 'Shipper Address 2'],
        key: 'shipper_address_2',
        search: false,
    },
    {
        title: 'Shipper City',
        dataIndex: ['rate_json', 'Shipper City'],
        key: 'shipper_city',
        search: false,
    },
    {
        title: 'ST',
        dataIndex: ['rate_json', 'ST'],
        key: 'st',
        search: false,
    },
    {
        title: 'Postal',
        dataIndex: ['rate_json', 'Postal'],
        key: 'postal',
        search: false,
    },
    {
        title: 'US Origin',
        dataIndex: ['rate_json', 'US Origin'],
        key: 'us_origin',
        search: false,
    },
    {
        title: 'Cntry1',
        dataIndex: ['rate_json', 'Cntry1'],
        key: 'cntry1',
        search: false,
    },
    {
        title: 'Region',
        dataIndex: ['rate_json', 'Region'],
        key: 'region',
        search: false,
    },
    {
        title: 'Recipient Name',
        dataIndex: ['rate_json', 'Recipient Name'],
        key: 'recipient_name',
        search: false,
    },
    {
        title: 'Recipient Company',
        dataIndex: ['rate_json', 'Recipient Company'],
        key: 'recipient_company',
        search: false,
    },
    {
        title: 'Recipient Address 1',
        dataIndex: ['rate_json', 'Recipient Address 1'],
        key: 'recipient_address_1',
        search: false,
    },
    {
        title: 'Recipient Address 2',
        dataIndex: ['rate_json', 'Recipient Address 2'],
        key: 'recipient_address_2',
        search: false,
    },
    {
        title: 'Recipient City',
        dataIndex: ['rate_json', 'Recipient City'],
        key: 'recipient_city',
        search: false,
    },
    {
        title: 'ST2',
        dataIndex: ['rate_json', 'ST2'],
        key: 'st2',
        search: false,
    },
    {
        title: 'Postal2',
        dataIndex: ['rate_json', 'Postal2'],
        key: 'postal2',
        search: false,
    },
    {
        title: 'Cntry2',
        dataIndex: ['rate_json', 'Cntry2'],
        key: 'cntry2',
        search: false,
    },
    {
        title: 'Dlvry Date',
        dataIndex: ['rate_json', 'Dlvry Date'],
        key: 'dlvry_date',
        search: false,
    },
    {
        title: 'Time',
        dataIndex: ['rate_json', 'Time'],
        key: 'time',
        search: false,
    },
    {
        title: 'Attempt Date',
        dataIndex: ['rate_json', 'Attempt Date'],
        key: 'attempt_date',
        search: false,
    },
    {
        title: 'Attempt Time',
        dataIndex: ['rate_json', 'Attempt Time'],
        key: 'attempt_time',
        search: false,
    },
    {
        title: 'Signature',
        dataIndex: ['rate_json', 'Signature'],
        key: 'signature',
        search: false,
    },
    {
      title:'Orig Recip Adr 1',
      dataIndex:['rate_json','Orig Recip Adr 1'],
      key:'orig_recip_adr_1',
      search:false,
    },
    {
        title: 'Orig Recip Adr 2',
        dataIndex: ['rate_json', 'Orig Recip Adr 2'],
        key: 'orig_recip_adr_2',
        search: false,
    },
    {
        title: 'Original City',
        dataIndex: ['rate_json', 'Original City'],
        key: 'original_city',
        search: false,
    },
    {
        title: 'ST3',
        dataIndex: ['rate_json', 'ST3'],
        key: 'st3',
        search: false,
    },
    {
        title: 'Postal3',
        dataIndex: ['rate_json', 'Postal3'],
        key: 'postal3',
        search: false,
    },
    {
        title: 'Multiweight Number',
        dataIndex: ['rate_json', 'Multiweight Number'],
        key: 'multiweight_number',
        search: false,
    }
]